var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8241 13.8725L10.5527 15.1017M19.0282 15.1017L17.7569 13.8725M12.2478 20.4285L11.4003 21.248M17.3331 20.4285L18.1806 21.248M14.7905 16.331V17.97L15.638 18.7895M14.7905 21.248C15.6896 21.248 16.5519 20.9026 17.1877 20.2879C17.8235 19.6731 18.1806 18.8394 18.1806 17.97C18.1806 17.1006 17.8235 16.2668 17.1877 15.6521C16.5519 15.0374 15.6896 14.692 14.7905 14.692C13.8913 14.692 13.029 15.0374 12.3932 15.6521C11.7575 16.2668 11.4003 17.1006 11.4003 17.97C11.4003 18.8394 11.7575 19.6731 12.3932 20.2879C13.029 20.9026 13.8913 21.248 14.7905 21.248Z",
    stroke: "#B1B1B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2266 9.87657V6.29902C17.2266 4.67446 17.2266 3.86219 16.8996 3.24169C16.612 2.69588 16.153 2.25213 15.5885 1.97403C14.9468 1.65787 14.1067 1.65787 12.4266 1.65787H6.02656C4.34641 1.65787 3.50633 1.65787 2.86459 1.97403C2.3001 2.25213 1.84116 2.69588 1.55354 3.24169C1.22656 3.86219 1.22656 4.67446 1.22656 6.29902V16.3548C1.22656 17.9794 1.22656 18.7917 1.55354 19.4122C1.84116 19.958 2.3001 20.4017 2.86459 20.6798C3.50633 20.996 4.34641 20.996 6.02656 20.996H9.22656M11.2266 10.36H5.22656M7.22656 14.2277H5.22656M13.2266 6.4924H5.22656",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/assessment_icon.e0a0d3f2969f74662305a0b35f0915a2.svg";
export { ForwardRef as ReactComponent };